import { TabsProps } from "antd/lib";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { useRecoilValue } from "recoil";
import { Tabs } from "../../Components";
import { PermissionDirect } from "../../Components/PermissionDirect";
import { UserAtom } from "../../store";
import { checkPermissions } from "../../utils/checkPermissions";
import { OilPriceTab } from "./OilPriceTab";
import { RefuelOilTab } from "./RefuelOilTab";
import { GasStation } from "../../Modules/GasStation/GasStation";

const oilTabKeys = ["1", "2", "3"];

const getSafeOilTab = (tab?: string | null) =>
  oilTabKeys.includes(String(tab)) ? String(tab) : "1";

export const Oil = () => {
  const history = useHistory();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const tabs = query.get("tabs");
  const permissionState = useRecoilValue<any>(UserAtom.permissions);
  const features = permissionState?.features;
  const [activeTab, setActiveTab] = useState(getSafeOilTab(tabs));

  const tabItems: TabsProps["items"] = [
    {
      key: "1",
      label: "Giá dầu",
      disabled: !checkPermissions("FUEL", "view", features),
    },
    {
      key: "2",
      label: "Đổ dầu",
      disabled: !checkPermissions("FUEL", "view", features),
    },
    {
      key: "3",
      label: "Trạm xăng dầu",
      disabled: !checkPermissions("FUEL", "view", features),
    },
  ];

  useEffect(() => {
    const nextTab = getSafeOilTab(tabs);

    if (activeTab !== nextTab) {
      setActiveTab(nextTab);
    }

    if (tabs !== nextTab) {
      history.replace(`/operation/oil?tabs=${nextTab}`);
    }
  }, [activeTab, history, tabs]);

  return (
    <PermissionDirect screen={["FUEL"]}>
      <Tabs
        items={tabItems}
        activeKey={activeTab}
        onChange={(tab) => {
          const nextTab = getSafeOilTab(tab);
          setActiveTab(nextTab);
          history.push(`/operation/oil?tabs=${nextTab}`);
        }}
      />
      {activeTab === "1" && <OilPriceTab />}
      {activeTab === "2" && <RefuelOilTab />}
      {activeTab === "3" && <GasStation />}
    </PermissionDirect>
  );
};
